/**
 * Gallery helpers — bridges the "one project with many photos" data model
 * to the flat list the Lightbox consumes.
 */

/**
 * Returns the list of photos for a project, always at least one entry
 * (falls back to the legacy cover fields when no photos array is set).
 */
export function projectPhotos(item) {
  const photos = Array.isArray(item?.photos) ? item.photos.filter((p) => p?.image_data || p?.image_url) : [];
  if (photos.length) return photos;
  if (item?.image_data || item?.image_url) {
    return [{ image_data: item.image_data, image_url: item.image_url || "" }];
  }
  return [];
}

/** Cover source (first photo, or legacy field). */
export function coverSrc(item) {
  const [first] = projectPhotos(item);
  return first?.image_data || first?.image_url || "";
}

/**
 * Flatten a list of gallery items into a per-photo slide list for the
 * Lightbox. Each slide keeps the parent project metadata plus its own
 * `image_data`/`image_url` for that specific photo, and additional
 * fields for the "Photo X / Y in project" indicator.
 */
export function flattenSlides(items) {
  const slides = [];
  (items || []).forEach((it) => {
    const photos = projectPhotos(it);
    // Ensure at least one slide so video-only projects still appear.
    const list = photos.length ? photos : [{ image_data: null, image_url: "" }];
    list.forEach((photo, i) => {
      slides.push({
        ...it,
        image_data: photo.image_data,
        image_url: photo.image_url || "",
        // Only the first (cover) slide of a project carries the video/media.
        video_url: i === 0 ? it.video_url : "",
        _project_id: it.id,
        _photo_index: i,
        _photo_count: list.length,
      });
    });
  });
  return slides;
}

/**
 * Given a flat slide list and a project id, return the index of the
 * first slide belonging to that project.
 */
export function firstSlideIndex(slides, projectId) {
  return slides.findIndex((s) => s._project_id === projectId);
}
